import axios from "axios";
import { Part } from "../../CarPartsModule/Types/part";
import { Vehicle } from "../../CarPartsModule/Types/vehicle";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/search`;

export interface VinSearchResponse {
  vehicle: Vehicle;
  parts: Part[];
}

export const searchPartsByVin = async (
  vin: string,
): Promise<VinSearchResponse> => {
  const res = await axios.post(`${BASE_URL}/vin`, { vin });
  return res.data;
};
